import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state() {
    return {
      userToken: '',
      email: '',
      id: '',
      accepted_eula: false,
      force_password_reset: false,
      companies: [],
      matrixReloadNeeded: false,
      rowData: [],
      columnDefs: [],
      localStorageItems: ['id', 'email', 'accepted_eula', 'force_password_reset'],
      accountTypeUpdates: []
    }
  },
  mutations: {
    setToken(state, token) {
      state.userToken = token !== 'undefined' && token !== undefined ? token : state.userToken
      window.localStorage.setItem('token', token)
    },
    setUserData(state, { email, id, accepted_eula, force_password_reset }) {
      state.email = email ? email : state.email
      state.id = id ? id : state.id
      state.accepted_eula = typeof accepted_eula === 'boolean' ? accepted_eula : state.accepted_eula
      state.force_password_reset = force_password_reset ? force_password_reset : state.force_password_reset
      for (let item of state.localStorageItems) {
        window.localStorage.setItem(item, state[`${item}`])
      }
    },
    logout(state) {
      state.userToken = ''
      window.localStorage.removeItem('token')
      // Clear them, then delete them, on suspicion of caching problems
      for (let item of state.localStorageItems) {
        window.localStorage.setItem(item, null)
      }
      for (let item of state.localStorageItems) {
        window.localStorage.removeItem(item)
      }
    },
    setCompanyList(state, companyList) {
      state.companies = [...companyList]
    },
    setMatrixReloadNeeded(state, flag) {
      state.matrixReloadNeeded = flag
    },
    setRowData(state, rowData) {
      state.rowData = [...rowData]
    },
    setColumnData(state, columnData) {
      state.columnDefs = [...columnData]
    },
    updateAccountType(state, payload) {
      state.accountTypeUpdates.push(payload)
    },
    clearAccountTypeUpdates(state) {
      state.accountTypeUpdates = [];
    }
  },
  getters: {
    isLoggedIn(state) {
      return state.userToken !== ''
    },
    hasAcceptedEula(state) {
      return state.accepted_eula
    },
    requiresPasswordReset(state) {
      return state.force_password_reset
    },
    baseURL() {
      const base = (config) ? config.VUE_APP_ENV_BASE_URL : process.env.VUE_APP_API_URL
      return base
    },
    userName(state) {
      return `${state.email}`
    },
    getAccountTypeUpdates(state) {
      return state.accountTypeUpdates
    }
  },
  actions: {
    persistLogin(context) {
      const token = window.localStorage.getItem('token')
      if (token) {
        context.commit('setToken', window.localStorage.getItem('token'))
        const stored_eula_status = window.localStorage.getItem('accepted_eula')
        context.commit('setUserData', {
          accepted_eula: stored_eula_status === 'false' || stored_eula_status === null ? false : true,
          email: window.localStorage.getItem('email'),
          id: Number(window.localStorage.getItem('id')),
        })
      }
    },
    triggerAccountTypeUpdate({ commit }, payload) {
      commit('updateAccountType', payload);
    }
  }
})
